<template>
  <div class="wrap">
    <!--符号 start-->
    <div class="mul1">×</div>
    <div class="mul2">×</div>
    <div class="mul3">×</div>
    <div class="mul4">÷</div>
    <div class="mul5">÷</div>
    <div class="div1">×</div>
    <div class="div2">×</div>
    <div class="div3">÷</div>
    <div class="div4">÷</div>
    <div class="div5">÷</div>
    <div class="div6">÷</div>
    <!--符号   end-->

    <div class="node node-row-1">
      <p class="key">{{flowChart[19].indicator_name}}(%)</p>
      <p class="value">{{flowChart[19].fact_value}}</p>
    </div>

    <div class="link h-rootlink"></div>
    <!-- 二 -->
    <div class="node node-row-2-1">
      <p class="key">{{flowChart[10].indicator_name}}(%)</p>
      <p class="value">{{flowChart[10].fact_value}}</p>
    </div>
    <div class="node node-row-2-2">
      <p class="key">{{flowChart[11].indicator_name}}(次)</p>
      <p class="value">{{flowChart[11].fact_value}}</p>
    </div>
    <div class="node node-row-2-3">
      <p class="key">{{flowChart[18].indicator_name}}</p>
      <p class="value">{{flowChart[18].fact_value}}</p>
    </div>

    <div class="link h-linktwo-1"></div>
    <div class="link h-linktwo-2"></div>
    <div class="link h-linktwo-3"></div>

    <!-- 三 -->

    <div class="node node-row-3-1">
      <p class="key">{{flowChart[8].indicator_name}}(%)</p>
      <p class="value">{{flowChart[8].fact_value}}</p>
    </div>
    <div class="node node-row-3-2">
      <p class="key">{{flowChart[9].indicator_name}}(%)</p>
      <p class="value">{{flowChart[9].fact_value}}</p>
    </div>
    <div class="node node-row-3-3">
      <p class="key">{{flowChart[1].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[1].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[1].fact_value/10000}}</p>
    </div>
    <div class="node node-row-3-4">
      <p class="key">{{flowChart[14].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[14].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[14].fact_value/10000}}</p>
    </div>
    <div class="node node-row-3-5">
      <p class="key">{{flowChart[14].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[14].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[14].fact_value/10000}}</p>
    </div>
    <div class="node node-row-3-6">
      <p class="key">{{flowChart[17].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[17].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[17].fact_value/10000}}</p>
    </div>
    <div class="link h-linkthird-1"></div>
    <div class="link h-linkthird-2"></div>
    <div class="link v-linktwo-1"></div>
    <div class="link v-linktwo-1-2"></div>
    <!-- 四 -->
    <div class="node node-row-4-1">
      <p class="key">{{flowChart[4].indicator_name}}(%)</p>
      <p class="value">{{flowChart[4].fact_value}}</p>
    </div>
    <div class="node node-row-4-2">
      <p class="key">{{flowChart[5].indicator_name}}(%)</p>
      <p class="value">{{flowChart[5].fact_value}}</p>
    </div>
    <div class="node node-row-4-3">
      <p class="key">{{flowChart[6].indicator_name}}(%)</p>
      <p class="value">{{flowChart[6].fact_value}}</p>
    </div>
    <div class="node node-row-4-4">
      <p class="key">{{flowChart[7].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[7].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[7].fact_value/10000}}</p>
    </div>
    <div class="node node-row-4-5">
      <p class="key">{{flowChart[2].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[2].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[2].fact_value/10000}}</p>
    </div>
    <div class="node node-row-4-6">
      <p class="key">{{flowChart[12].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[12].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[12].fact_value/10000}}</p>
    </div>
    <div class="node node-row-4-7">
      <p class="key">{{flowChart[15].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[15].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[15].fact_value/10000}}</p>
    </div>

    <div class="link v-linktwo-2"></div>
    <div class="link v-linktwo-2-2"></div>
    <div class="link v-linktwo-2-3"></div>

    <div class="node node-row-5-1">
      <p class="key">{{flowChart[0].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[0].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[0].fact_value/10000}}</p>
    </div>

    <div class="node node-row-5-2">
      <p class="key">{{flowChart[2].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[2].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[2].fact_value/10000}}</p>
    </div>

    <div class="node node-row-5-3">
      <p class="key">{{flowChart[3].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[3].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[3].fact_value/10000}}</p>
    </div>
    <div class="node node-row-5-4">
      <p class="key">{{flowChart[13].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[13].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[13].fact_value/10000}}</p>
    </div>
    <div class="node node-row-5-5">
      <p class="key">{{flowChart[16].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[16].fact_value=='--'">--</p>
      <p class="value" v-else>{{flowChart[16].fact_value/10000}}</p>
    </div>

    <div class="node node-row-6-1">
      <p class="key">{{flowChart[1].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[1].fact_value=='--'">--</p> 
      <p class="value" v-else>{{flowChart[1].fact_value/10000}}</p> 
    </div>
    <div class="node node-row-6-2">
      <p class="key">{{flowChart[3].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[3].fact_value=='--'">--</p> 
      <p class="value" v-else>{{flowChart[3].fact_value/10000}}</p> 
    </div>
    <div class="node node-row-6-3">
      <p class="key">{{flowChart[0].indicator_name}}(万元)</p>
      <p class="value" v-if="flowChart[0].fact_value=='--'">--</p> 
      <p class="value" v-else>{{flowChart[0].fact_value/10000}}</p> 
    </div>
  </div>
</template>
<script>
export default {
  props: ["flowChart"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped lang="less">
.wrap {
  width: 1330px;
  height: 630px;
  position: relative;
   color:#fff;
}

.mul1 {
  top: 162px;
  left: 472px;
  position: absolute;
}
.mul2 {
  top: 162px;
  left: 838px;
  position: absolute;
}
.mul3 {
  top: 252px;
  left: 283px;
  position: absolute;
}
.mul4 {
  top: 252px;
  left: 663px;
  position: absolute;
}
.mul5 {
  top: 252px;
  left: 1013px;
  position: absolute;
}

.div1 {
  top: 355px;
  left: 113px;
  position: absolute;
}
.div2 {
  top: 355px;
  left: 267px;
  position: absolute;
}
.div3 {
  top: 355px;
  left: 579px;
  position: absolute;
}
.div4 {
  top: 499px;
  left: 108px;
  position: absolute;
}
.div5 {
  top: 499px;
  left: 263px;
  position: absolute;
}
.div6 {
  top: 499px;
  left: 416px;
  position: absolute;
}

.h-linkthird-1 {
  width: 316px;
  height: 19px;
  top: 300px;
  left: 42px;
  position: absolute;
  background: url("http://n.sinaimg.cn/finance/dbfx/h-linkthird-1.png")
    no-repeat;
  background-size: 100% 100%;
}
.h-linkthird-2 {
  width: 310px;
  height: 20px;
  top: 300px;
  left: 368px;
  position: absolute;
  background: url("http://n.sinaimg.cn/finance/dbfx/h-linkthird-2.png")
    no-repeat;
  background-size: 100% 100%;
}
.v-linktwo-1,
.v-linktwo-1-2 {
  width: 6px;
  height: 170px;
  top: 300px;
  left: 934px;
  position: absolute;
  background: url("http://n.sinaimg.cn/finance/dbfx/v-linktwo-1.png") no-repeat;
  background-size: 100% 100%;
}

.v-linktwo-1-2 {
  left: 1099px;
}
// 整体
.node {
  width: 126px;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #bad2ed;
}
.key {
  font-size: 12px;
  height: 52px;
  line-height: 52px;
  background-color: #e5f0ff;
  position: relative;
  color:#000;
}
.value {
  border-top: 1px solid #bad2ed;
  height: 26px;
  line-height: 26px;
}
// 多行换行
.node-row-2-1 .key {
  height: 44px;
  white-space:normal;
  line-height: 20px;
  padding-top: 8px;
  padding-left: 11px;
  padding-right: 10px; 
}
.node-row-3-6 .key {
  height: 44px;
  white-space:normal;
  line-height: 20px;
  padding-top: 8px;
  padding-left: 11px;
  padding-right: 10px; 
}
.node-row-3-2 .key {
  height: 44px;
  white-space:normal;
  line-height: 20px;
  padding-top: 8px;
  padding-left: 11px;
  padding-right: 10px; 
}
.node-row-4-4 .key {
  height: 44px;
  white-space:normal;
  line-height: 20px;
  padding-top: 8px;
  padding-left: 11px;
  padding-right: 10px; 
}
.node-row-4-7 .key {
  height: 44px;
  white-space:normal;
  line-height: 20px;
  padding-top: 8px;
  padding-left: 11px;
  padding-right: 10px; 
}
.node-row-5-5 .key {
  height: 44px;
  white-space:normal;
  line-height: 20px;
  padding-top: 8px;
  padding-left: 11px;
  padding-right: 10px; 
}

// 第一行
.node-row-1 {
  top: 20px;
  left: 600px;
  position: absolute;
}

.h-rootlink {
  width: 728px;
  height: 20px;
  top: 100px;
  left: 287px;
  position: absolute;
  background: url("http://n.sinaimg.cn/finance/dbfx/h-rootlink.png") no-repeat;
  background-size: 100% 100%;
}
//  第二行
.node-row-2-1 {
  top: 120px;
  left: 222px;
  position: absolute;
}


.node-row-2-2 {
  top: 120px;
  left: 600px;
  position: absolute;
}
.node-row-2-3 {
  top: 120px;
  left: 946px;
  position: absolute;
}
// 线
.h-linktwo-1 {
  width: 168px;
  height: 20px;
  top: 200px;
  left: 200px;
  position: absolute;
  background: url("http://n.sinaimg.cn/finance/dbfx/h-linktwo-1.png") no-repeat;
  background-size: 100% 100%;
}

.h-linktwo-2 {
  width: 168px;
  height: 20px;
  top: 200px;
  left: 581px;
  position: absolute;
  background: url("http://n.sinaimg.cn/finance/dbfx/h-linktwo-2.png") no-repeat;
  background-size: 100% 100%;
}

.h-linktwo-3 {
  width: 168px;
  height: 20px;
  top: 200px;
  left: 932px;
  position: absolute;
  background: url("http://n.sinaimg.cn/finance/dbfx/h-linktwo-3.png") no-repeat;
  background-size: 100% 100%;
}

//  第三行
.node-row-3-1 {
  top: 219px;
  left: 137px;
  position: absolute;
}
.node-row-3-2 {
  top: 219px;
  left: 305px;
  position: absolute;
}
.node-row-3-3 {
  top: 219px;
  left: 518px;
  position: absolute;
}
.node-row-3-4 {
  top: 219px;
  left: 687px;
  position: absolute;
}
.node-row-3-5 {
  top: 219px;
  left: 869px;
  position: absolute;
}
.node-row-3-6 {
  top: 219px;
  left: 1035px;
  position: absolute;
}
//  第四行
.node-row-4-1 {
  top: 319px;
  left: 0px;
  position: absolute;
  transform: translate(-20%, 0);
}
.node-row-4-2 {
  top: 319px;
  left: 130px;
  position: absolute;
}
.node-row-4-3 {
  top: 319px;
  left: 284px;
  position: absolute;
}
.node-row-4-4 {
  top: 319px;
  left: 436px;
  position: absolute;
}
.node-row-4-5 {
  top: 319px;
  left: 600px;
  position: absolute;
}
.node-row-4-6 {
  top: 319px;
  left: 940px;
  position: absolute;
}
.node-row-4-7 {
  top: 319px;
  left: 1105px;
  position: absolute;
}
//线
.v-linktwo-2,
.v-linktwo-2-2,
.v-linktwo-2-3 {
  width: 6px;
  height: 170px;
  top: 400px;
  left: 44px;
  position: absolute;
  background: url("http://n.sinaimg.cn/finance/dbfx/v-linktwo-2.png") no-repeat;
  background-size: 100% 100%;
}

.v-linktwo-2-2 {
  left: 198px;
}

.v-linktwo-2-3 {
  left: 353px;
}

// 第五行
.node-row-5-1 {
  top: 405px;
  left: 49px;
  position: absolute;
}

.node-row-5-2 {
  top: 405px;
  left: 204px;
  position: absolute;
}

.node-row-5-3 {
  top: 405px;
  left: 358px;
  position: absolute;
}

.node-row-5-4 {
  top: 424px;
  left: 940px;
  position: absolute;
}

.node-row-5-5 {
  top: 424px;
  left: 1105px;
  position: absolute;
}
// 第六行
.node-row-6-1 {
  top: 528px;
  left: 49px;
  position: absolute;
}
.node-row-6-2 {
  top: 528px;
  left: 204px;
  position: absolute;
}
.node-row-6-3 {
  top: 528px;
  left: 358px;
  position: absolute;
}
</style>







// WEBPACK FOOTER //
// src/components/analyze/dupont.vue